import React, { useState } from "react";
import Expander from "@amzn/meridian/expander";

export default function ControlledExpander(props) {
  const [open, setOpen] = useState();
  return <Expander open={open} onChange={setOpen} {...props} />; // content shown in children prop
}
